export default __webpack_public_path__ + "static/Card25-8e9f4a974f262d248b9c30166101439c.png";